export const skillEvaluationMap = {
  "無し": {
    "0": 0,
    "1": 0,
    "2": 0,
    "3": 0,
    "4": 0,
    "5": 0,
    "6": 0,
    "7": 0
  },
  "火耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "水耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "雷耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "氷耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "龍耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "毒耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "麻痺耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "睡眠耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "爆破やられ耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "植生学": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "地質学": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "飛び込み": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "陽動": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "泥雪耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "満足感": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "腹減り耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "剥ぎ取り鉄人": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "防御": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 4,
    "6": 5,
    "7": 6
  },
  "火属性攻撃強化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "水属性攻撃強化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "雷属性攻撃強化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "氷属性攻撃強化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "龍属性攻撃強化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "ボマー": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "滑走強化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "毒属性強化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "スタミナ奪取": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "笛吹き名人": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "回復速度": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "砥石使用高速化": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "風圧耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "ひるみ軽減": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "ブレ抑制": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "気絶耐性": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "装填速度": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "反動軽減": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "不屈": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "乗り名人": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "体術": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "体力回復量UP": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "アイテム使用強化": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 4,
    "4": 6,
    "5": 8,
    "6": 8,
    "7": 10
  },
  "翔蟲使い": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "壁面移動": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 4,
    "4": 6,
    "5": 8,
    "6": 8,
    "7": 10
  },
  "精霊の加護": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "早食い": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "属性やられ耐性": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "破壊王": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "広域化": {
    "0": 0,
    "1": 2,
    "2": 3,
    "3": 3,
    "4": 4,
    "5": 6,
    "6": 6,
    "7": 7
  },
  "KO術": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "納刀術": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "回避性能": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "回避距離UP": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "抜刀術【力】": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "泡沫の舞": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "逆襲": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "耐震": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "鈍器使い": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "高速変形": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "見切り": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "攻撃": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "渾身": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "強化持続": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "スタミナ急速回復": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "ガード性能": {
    "0": 0,
    "1": 2,
    "2": 3,
    "3": 5,
    "4": 6,
    "5": 8,
    "6": 9,
    "7": 11
  },
  "ガード強化": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "砲弾装填": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "特殊射撃強化": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "火事場力": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "心眼": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "集中": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "ランナー": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "砲術": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "会心撃【属性】": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "弾導強化": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "超会心": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "弱点特効": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "挑戦者": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "フルチャージ": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "逆恨み": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "死中に活": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "力の解放": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "麻痺属性強化": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "睡眠属性強化": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "爆破属性強化": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "剛刃研磨": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "業物": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "弾丸節約": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "達人芸": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "耳栓": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "抜刀術【技】": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "キノコ大好き": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "攻めの守勢": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "装填拡張": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "通常弾・連射矢強化": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "貫通弾・貫通矢強化": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "散弾・拡散矢強化": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "速射強化": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "ジャンプ鉄人": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "鬼火纏": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "幸運": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "匠": {
    "0": 0,
    "1": 3,
    "2": 4,
    "3": 7,
    "4": 8,
    "5": 11,
    "6": 12,
    "7": 15
  },
  "壁面移動【翔】": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "刃鱗磨き": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "合気": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "疾之息吹": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "弓溜め段階解放": {
    "0": 0,
    "1": 4,
    "2": 8,
    "3": 12,
    "4": 16,
    "5": 20,
    "6": 24,
    "7": 28
  },
  "研磨術【鋭】": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "チューンアップ": {
    "0": 0,
    "1": 3,
    "2": 6,
    "3": 9,
    "4": 12,
    "5": 15,
    "6": 18,
    "7": 21
  },
  "チャージマスター": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "災禍転福": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "供応": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "顕如盤石": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  },
  "攻勢": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "連撃": {
    "0": 0,
    "1": 2,
    "2": 4,
    "3": 6,
    "4": 8,
    "5": 10,
    "6": 12,
    "7": 14
  },
  "霞皮の恩恵": {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7
  }
}
